import React from 'react';
import Img from 'gatsby-image';
import Layout from "../layouts/index";
import '../style/index.scss';
import { graphql } from 'gatsby';
import Carousel from "react-slick";
import Cookies from 'js-cookie';
import { GlobalContext } from '../context/globalContext';
import * as JsSearch from 'js-search';
import ProductTile from '../components/productTile';
import SEO from '../components/seo'
import i18next from 'i18next';
import Modal from 'react-modal';
import NewsletterForm from '../components/newsletterForm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logoSVG from '../resources/images/logo/mainlogo.svg';

Modal.setAppElement(`#___gatsby`);

let search= '';
const settings = {
    autoplay: true,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
};

const modalStyles = {
    content : {
        top         : '50%',
        left        : '50%',
        right       : 'auto',
        bottom      : 'auto',
        marginRight : '-50%',
        transform   : 'translate(-50%, -50%)'
    }
};

const settingsNewProducts = {
    autoplay: false,
    dots: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                dots: true
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
};

class IndexPage extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            search: '',
            carouselNewsArray: [],
            carouselTopArray: [],
            showPopupNewsletter: false
        }
    }
    componentDidMount() {
        const data = this.props.data;
        search = new JsSearch.Search('id');
        search.indexStrategy = new JsSearch.ExactWordIndexStrategy();
        search.addIndex('marca');
        search.addIndex('modelo');
        search.addIndex('idarticulo');
        data.allDatoCmsProduct.edges.map(({ node: product }) => {            
            return search.addDocument(product);
        });
        let carouselNewsArray = [];
        let carouselTopArray = [];
        if (data.allDatoCmsHome.edges && data.allDatoCmsHome.edges[0].node && data.allDatoCmsHome.edges[0].node.newReleases) {
            if (data.allDatoCmsHome.edges[0].node.newReleases && data.allDatoCmsHome.edges[0].node.newReleases[0].products) {
                let prodArray = data.allDatoCmsHome.edges[0].node.newReleases[0].products.map(product => {
                    return product.idarticulo;
                });
                carouselNewsArray = prodArray;
            }
            if (data.allDatoCmsHome.edges[0].node.topSellers && data.allDatoCmsHome.edges[0].node.topSellers[0].products) {
                let prodArray = data.allDatoCmsHome.edges[0].node.topSellers[0].products.map(product => {
                    return product.idarticulo;
                });
                carouselTopArray = prodArray;
            }
        }
        this.setState({
            search: search,
            carouselNewsArray: carouselNewsArray,
            carouselTopArray: carouselTopArray
        });

        if(Cookies.get('popupnewsletter') === undefined) {
            this.setState({
                showPopupNewsletter: true
            });
        }
    }

    /**
    * @function setAutoPlayToCarousel
    * @desc this function set autoplay to the carousel settings depending of the array size
    * @param {*} carouselArray  - cross sell elements array
    */
    setAutoPlayToCarousel = (carouselArray) => {
       if(carouselArray.length >= settingsNewProducts.slidesToShow) {
            settingsNewProducts.infinite = true;
            settingsNewProducts.autoplay = true;
       } else {
            settingsNewProducts.infinite = false;
            settingsNewProducts.autoplay = false;
       }
       settingsNewProducts.responsive.map(breakpoint => {
           if(breakpoint.settings.slidesToShow <= carouselArray.length) {
               breakpoint.settings.infinite = true;
               breakpoint.settings.autoplay = true;
               return '';
           } else {
               breakpoint.settings.infinite = false;
               breakpoint.settings.autoplay = false;
               return '';
           }
       });
    }

    closePopupNewsletter = () => {
        Cookies.set('popupnewsletter', 'closed', { expires: 15 });
        this.setState({
            showPopupNewsletter: false
        });
    }

    render() {
        const data = this.props.data;
        const carouselNewsArray = this.state.carouselNewsArray;
        const carouselTopArray = this.state.carouselTopArray;
        const carouselNewsTitle = (data.allDatoCmsHome.edges && data.allDatoCmsHome.edges[0].node && data.allDatoCmsHome.edges[0].node.newReleases && data.allDatoCmsHome.edges[0].node.newReleases[0].title ?  data.allDatoCmsHome.edges[0].node.newReleases[0].title : i18next.t('HP_NEW_RELEASES'));
        const carouselTopTitle = (data.allDatoCmsHome.edges && data.allDatoCmsHome.edges[0].node && data.allDatoCmsHome.edges[0].node.topSellers && data.allDatoCmsHome.edges[0].node.topSellers[0].title ?  data.allDatoCmsHome.edges[0].node.topSellers[0].title : i18next.t('HP_TOP_SELLERS'));
        this.setAutoPlayToCarousel(carouselNewsArray);
        this.setAutoPlayToCarousel(carouselTopArray);
        const seo = data.allDatoCmsHome.edges[0].node.seo;
        return(
            <Layout children={null} data={data}>
                <SEO 
                    title={seo.seo.title}
                    keywords={seo.keywords}
                    slug=''
                    description={seo.seo.description}
                    lang={seo.locale}
                    contactinfo={JSON.parse(data.contactinfo.data)}
                />

                <div>
                    <Modal
                        isOpen={this.state.showPopupNewsletter}
                        ariaHideApp={false}
                        style={modalStyles}
                        onRequestClose={this.closePopupNewsletter}
                    >
                        <div className="home__newsletter-close" onClick={this.closePopupNewsletter}>
                            <FontAwesomeIcon className="icon-close" icon="times" />
                        </div>
                        <div className="home__newsletter-main">
                            <div className="home__newsletter-img">
                                <img className="lazyload" src="https://www.datocms-assets.com/34634/1602354240-newsletter.png" alt="newsletter"/>
                            </div>
                            <div className="home__newsletter-content">
                                <div className="logo">
                                    <img className="lazyload" data-src={logoSVG} alt="eyewear concept logo" />
                                </div>
                                <div className="text" dangerouslySetInnerHTML={{__html: data.popupnewsletter.text}}></div>
                                <div className="form">
                                    <NewsletterForm/>
                                </div>
                            </div>
                        </div>
                    </Modal>
                    {
                        data.allDatoCmsHome.edges.map(({node: content}, index) => (
                            <div className="home" key={index}>
                                <GlobalContext.Consumer>
                                    {state => {
                                        let carousel = '';
                                        state.isMobile ? carousel = content.carouselMobile : carousel = content.carouselDesktop;
                                        return (
                                            <Carousel {...settings} className="home__carousel">
                                                {
                                                    carousel.map((image, index) => (
                                                        <div key={index}>
                                                            <Img fluid={image.fluid} alt="" loading="lazy" fadeIn/>
                                                        </div>
                                                    ))            
                                                }
                                            </Carousel>
                                        );
                                    }}
                                </GlobalContext.Consumer>
                                <div className="home__new-carousel">
                                    {    
                                        carouselNewsArray.length >= 1 ? 
                                            <>
                                                <div className="section-title">
                                                    <h2>{carouselNewsTitle}</h2>
                                                </div>
                                                <Carousel {...settingsNewProducts} className="home__new-releases">
                                                {
                                                    carouselNewsArray.map((product, index) => {
                                                        if(this.state.search) {
                                                            let prod = search.search(product);
                                                            if(prod !== -1) {
                                                                return (
                                                                    <ProductTile key={index} locale={this.props.pageContext.locale} product={prod[0]} data={data}></ProductTile>
                                                                )
                                                            } else {
                                                                return '';
                                                            }
                                                        } else {
                                                            return '';
                                                        }
                                                    })           
                                                }
                                                </Carousel>
                                            </>
                                        : ''
                                    }
                                </div>
                                <div className="home__top-carousel">
                                    {    
                                        carouselTopArray.length >= 1 ? 
                                            <>
                                                <div className="section-title">
                                                    <h2>{carouselTopTitle}</h2>
                                                </div>
                                                <Carousel {...settingsNewProducts} className="home__top-sellers">
                                                {
                                                    carouselTopArray.map((product, index) => {
                                                        if(this.state.search) {
                                                            let prod = search.search(product);
                                                            if(prod !== -1) {
                                                                return (
                                                                    <ProductTile key={index} locale={this.props.pageContext.locale} product={prod[0]} data={data}></ProductTile>
                                                                )
                                                            } else {
                                                                return '';
                                                            }
                                                        } else {
                                                            return '';
                                                        }
                                                    })           
                                                }
                                                </Carousel>
                                            </>
                                        : ''
                                    }
                                </div>

                                <div className="home__grid">
                                    <h1 className="home__grid-title">
                                        <span dangerouslySetInnerHTML={{__html: content.hpContentGridTitle}}></span>
                                    </h1>
                                    <div className="home__grid-wrapper">
                                        {
                                            content.hpContentGrid.map((gridItem, index) => (
                                                <div className={"home__item" + (gridItem.fullWidth ? " fullWidth" : "")} key={index}>
                                                    <Img fluid={gridItem.gridItemImage.fluid} alt="" loading="lazy" fadeIn/>
                                                    <span className="home__item-title" dangerouslySetInnerHTML={{__html: gridItem.gridItemTitle}}></span>
                                                    <div className="home__item-text" dangerouslySetInnerHTML={{__html: gridItem.gridItemText}}></div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            
                                <div className="home__content-bottom">
                                    {
                                        content.hpContentBottom.map((item, index) => (
                                            <div className="content-bottom__wrapper" key={index}>
                                                <h1 className="content-bottom__title">
                                                    <span dangerouslySetInnerHTML={{__html: item.contentBottomTitle}}></span>
                                                </h1>
                                                <div className="content-bottom__text" dangerouslySetInnerHTML={{__html: item.contentBottomText}}></div>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                            
                        ))
                    }
                </div>
            </Layout>
        );
    }
}

export default IndexPage
/* HomepageQuery */
export const query = graphql`
query ($locale: String = "en") {
  categories: allDatoCmsCategory(sort: {order: ASC, fields: sequence}, filter: {top: {eq: true}, locale: {eq: $locale}}) {
    edges {
      node {
        id
        name
        url
        sequence
        locale
        subcategory {
          id
          name
          url
          locale
          sequence
          subcategory {
            id
            name
            url
            locale
            sequence
          }
        }
      }
    }
  }
  allDatoCmsHome(filter: {locale: {eq: $locale}}) {
    edges {
      node {
        carouselDesktop {
            url
            fluid(maxWidth: 1920) {
                ...GatsbyDatoCmsFluid
            }
        }
        carouselMobile {
            url
            fluid(maxWidth: 1024) {
                ...GatsbyDatoCmsFluid
            }
        }
        topSellers {
            title
            products {
                id
                marca
                idarticulo
                modelo
                descripcion
                descripcionampliada
            }
        }
        newReleases {
            title
            products {
                id
                marca
                idarticulo
                modelo
                descripcion
                descripcionampliada
            }
        }
        hpContentGridTitle
        hpContentGrid {
          gridItemImage {
            url
            fluid(maxWidth: 650) {
                ...GatsbyDatoCmsFluid
            }
          }
          gridItemTitle
          gridItemText
          fullWidth
        }
        hpContentBottom {
          contentBottomTitle
          contentBottomText
        }
        seo {
            id
            locale
            seo {
              description
              title
              image {
                id
                url
              }
            }
            slug
            keywords
        }
      }
    }
  }
  contentPages: allDatoCmsContentPage(filter: {locale: {eq: $locale}}) {
    edges {
        node {
            locale
            url
            cpContentGridTitle
        }
    }
}
  allDatoCmsProduct(filter: {locale: {eq: $locale}}) {
    edges {
        node {
            id
            descripcion
            descripcionampliada
            categoria
            categorias {
                id
                name
                url
                locale
                sequence
            }
            polarizacion
            locale
            marca
            modelo
            idarticulo
            images
            weight
            offerpriceeur
            offerpricegbp
            offerpriceusd
            listpriceeur
            listpricegbp
            listpriceusd
            crosssell
            meta {
              createdAt
            }
        }
    }
  }
  allDatoCmsFooter(filter: {locale: {eq: $locale}}) {
    edges {
      node {
        footerLinksList
        footerCopyright
        footerPayments
      }
    }
  }
  contactinfo : datoCmsExtrainfo(name: {eq: "contactinfo"}, locale: {eq: $locale}) {
      data
  }
  popupnewsletter : datoCmsExtrainfo(name: {eq: "popup-newsletter"}, locale: {eq: $locale}) {
      text
  }
  newBadgeDays : datoCmsExtrainfo(name: {eq: "NewBadge_Constant"}, locale: {eq: $locale}) {
      data
  }
  ddm : allDatoCmsDdm(filter: {locale: {eq: $locale}}) {
      nodes {
          submenu {
              header
              directLink
              menu
          }
      }
  }
}
`